<template lang="pug">
  div.points-info-container
    .container-left
      .points-area(@click="handlePointsClick")
        .points-amount {{ bountyLoaded ? points : '--' }}
        .points-unit 金币
        img.arrow-icon(
          src="https://m.hellobike.com/resource/gallery/833/tyHndEjVPP.png"
        )
      .money-area
        .gold-cash-area
          .gold-cash-symbol ≈
          .gold-cash {{ bountyLoaded ? bounty : '--' }}
          .gold-cash-unit 元现金
        .gold-withdraw-area(
          v-if="showBonusWithdrawalScene"
          @click="goCashWithdraw"
        )
          .gold-withdraw 去提现
            .icon-arrow
    .container-right
      slot(name="right")
</template>

<script>
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import SPM from '../common/spm';
import { BONUS_WITHDRAWAL_SCENE } from '../consts';

export default {
  name: 'PointsInfo',
  props: {
    // 积分
    points: {
      type: Number,
      default: 0,
    },
    // 可抵额度
    bounty: {
      type: Number,
      default: 0,
    },
    // 奖励金加载状态
    bountyLoaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  inject: ['bonusWithdrawalScene'],
  computed: {
    // 是否展示提现入口
    showBonusWithdrawalScene() {
      return this.bonusWithdrawalScene() === BONUS_WITHDRAWAL_SCENE.SHOW;
    },
  },
  mounted() {
    // 奖励金信息模块曝光埋点
    SPM.moduleExpose({
      moduleId: 'my_bonus_new',
      contentId: 'my_bonus_new',
      businessInfo: {},
    });
  },
  methods: {
    // 点击积分信息
    handlePointsClick() {
      this.$emit('pointsClick');
    },
    // 去提现页面
    goCashWithdraw() {
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/welfare/withdraw`,
      );
      // 提现入口点击埋点
      SPM.clickButton({
        pageId: 'welfare_new',
        buttonName: 'platform_tixianrukou',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.points-info-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.33rem 0 0.24rem;
  height: 0.6rem;

  .points-area {
    display: flex;
    align-items: flex-end;

    .points-amount {
      font-family: 'DIN Alternate Bold', sans-serif;
      font-weight: 700;
      font-size: 0.3rem;
      line-height: 0.35rem;
      color: #fff;
    }

    .points-unit {
      font-size: 0.12rem;
      margin-left: 0.04rem;
      line-height: 0.24rem;
      color: #fff;
    }

    .arrow-icon {
      margin-left: 0.03rem;
      width: 0.06rem;
      height: 0.1rem;
      transform: translateY(-0.08rem);
    }
  }

  .money-area {
    display: flex;
    align-items: center;
    color: #fff;
    margin-top: 0.06rem;

    .gold-cash-area {
      display: flex;
      align-items: center;
    }

    .gold-cash-symbol {
      font-weight: 400;
      font-size: 0.12rem;
      letter-spacing: 0;
      margin-right: 0.02rem;
      padding-bottom: 0.025rem;
    }

    .gold-cash {
      font-family: "DIN Alternate Bold", sans-serif;
      font-size: 0.15rem;
      letter-spacing: 0;
    }

    .gold-cash-unit {
      font-size: 0.12rem;
      letter-spacing: 0;
      margin-right: 0.08rem;
    }

    .gold-withdraw-area {
      display: flex;
      align-items: center;
    }

    .gold-withdraw {
      display: flex;
      align-items: center;
      padding-left: 0.07rem;
      width: 0.54rem;
      height: 0.18rem;
      border-radius: 0.09rem;
      border: 0.01rem solid rgba(251, 253, 255, 1);
      font-weight: 500;
      font-size: 0.11rem;
      line-height: 0.15rem;
      letter-spacing: 0;
      background:
        linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.14) 0%,
          rgba(255, 255, 255, 0.07) 100%
        );
      color: #fff;

      .icon-arrow {
        width: 0.1rem;
        height: 0.1rem;
        background: url('https://m.hellobike.com/resource/gallery/833/5xlfZ1LMC5.png') no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
